module.exports = __webpack_public_path__ + "img/wired-outline-56-document (1).06054048.gif";